// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Teller cash shortage'"></sub-header>
    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">
        <tbody>
        <tr>
          <td>1.</td>
          <td>Approval user:</td>
          <td>
            <user-select
                ng-model="\$ctrl.transaction.approvalUserId"
                users="\$ctrl.approvalUsers"
                ng-required="true"></user-select>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Amount of shortage:</td>
          <td>
            <cash ng-required="true"
              ng-model="\$ctrl.transaction.amount"
              min="0.01"></cash>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.transactionForm.\$pristine"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-danger"
          ng-disabled="\$ctrl.transactionForm.\$invalid"
          ng-click="\$ctrl.save()">
          Shortage
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/teller-cash-shortage/teller-cash-shortage.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;